import React, { FunctionComponent } from 'react';
import moment from 'moment';
import gray from '@material-ui/core/colors/grey';
import { Box, FormHelperText, Grid, Hidden, makeStyles, Theme } from '@material-ui/core';
import { FormFieldProps } from '../FormFieldDisplay';
import TimePicker from '../../../TimePicker';

const useStyles = makeStyles((theme: Theme) => ({
    inputCustomStyle: {
        fontSize: 13,
    },
    detailNodeLabelSm: {
        fontSize: 14,
        fontWeight: 500,
        color: theme.palette.text.secondary,
        textAlign: 'left',
        justifyContent: 'right',
        marginRight: 30,
        lineHeight: '21px',
    },
    detailNodeLabel: {
        fontSize: 14,
        fontWeight: 500,
        color: theme.palette.text.secondary,
        textAlign: 'right',
        justifyContent: 'right',
        marginRight: 30,
        lineHeight: '21px',
    },
    detailNodeValue: {
        fontSize: 14,
        fontWeight: 450,
        color: gray[600],
        lineHeight: '21px',
        wordWrap: 'break-word',
    },
    borderedInputs: {
        border: '1px solid rgb(0,0,0,0.23) !important',
        padding: 10,
        borderRadius: 3,
        marginBottom: '5px',
    },
    disabled: {
        color: '#484848 !important',
    },
    datePicker: {
        margin: 0,
    },
    datePickerContainer: {
        backgroundColor: 'white',
        borderRadius: 5,
        justifyContent: 'flex-start',
    },
    underline: {
        '&:before': {
            borderBottomColor: 'white',
        },
        '&:after': {
            borderBottomColor: 'white',
        },
        '&:hover:before': {
            borderBottomColor: ['white', '!important'],
        },
    },
    pickerUI: {
        width: '100%',
        marginBottom: '5px',
        '&>.MuiOutlinedInput-root': {
            '&>.MuiOutlinedInput-input': {
                padding: 10,
            },
            '&>.MuiInputAdornment-root': {
                '&>.MuiIconButton-root': {
                    padding: 0,
                },
            },
        },
        '&>.MuiOutlinedInput-adornedEnd': {
            paddingRight: '5px',
        },
    },
}));

const TimePickerFormField: FunctionComponent<FormFieldProps> = (props) => {
    const { formField, error, readOnly, handleInputChange, value, isCustomStyle } = props;
    const classes = useStyles();
    const timeValue = value ? moment(value, 'HH:mm:ss') : null;

    return (
        <Grid container alignItems="center">
            <Grid item xs={isCustomStyle ? 3 : 6}>
                <Hidden smUp={true}>
                    <Box component="div" className={classes.detailNodeLabelSm}>
                        {formField.label}
                    </Box>
                </Hidden>
                <Hidden xsDown={true}>
                    <Box component="div" className={classes.detailNodeLabel}>
                        {formField.label}
                    </Box>
                </Hidden>
            </Grid>
            <Grid item xs={isCustomStyle ? 9 : 6}>
                <Box component="div" className={classes.detailNodeValue}>
                    {!readOnly && (
                        <>
                            <TimePicker
                                className={classes.pickerUI}
                                value={value || null}
                                error={error?.error}
                                onChange={(time: string | null) => {
                                    handleInputChange(formField.field, time);
                                }}
                            />
                            {error?.messages?.map((msg, index) => (
                                <FormHelperText key={index} error={true}>
                                    {msg}
                                </FormHelperText>
                            ))}
                        </>
                    )}
                    {readOnly && (
                        <Box component="div" className={classes.detailNodeValue}>
                            {timeValue?.format('LT') ?? ''}
                        </Box>
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};

export default TimePickerFormField;
